import React, { Component } from 'react';

const BETA_STORAGE_KEY = 'primal_beta_access';
const IS_PROD = process.env.NODE_ENV === 'production';

class BetaGate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasAccess: IS_PROD || localStorage.getItem(BETA_STORAGE_KEY) === 'granted',
      password: '',
      error: '',
      shake: false,
    };
  }

  handleSubmit = (e) => {
    e.preventDefault();
    if (this.state.password === 'Revitalize2OP') {
      localStorage.setItem(BETA_STORAGE_KEY, 'granted');
      this.setState({ hasAccess: true, error: '' });
    } else {
      this.setState({ error: 'Incorrect password', shake: true });
      setTimeout(() => this.setState({ shake: false }), 500);
    }
  };

  handleChange = (e) => {
    this.setState({ password: e.target.value, error: '' });
  };

  render() {
    if (this.state.hasAccess) {
      return this.props.children;
    }

    return (
      <div style={{
        position: 'fixed',
        inset: 0,
        zIndex: 99999,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#0a0a0f',
        fontFamily: "'Lato', sans-serif",
      }}>
        {/* Background pattern */}
        <div style={{
          position: 'absolute',
          inset: 0,
          opacity: 0.05,
          backgroundImage: 'radial-gradient(circle at 25% 25%, #c9a84c 1px, transparent 1px), radial-gradient(circle at 75% 75%, #c9a84c 1px, transparent 1px)',
          backgroundSize: '50px 50px',
        }} />

        <div
          style={{
            position: 'relative',
            width: '100%',
            maxWidth: 420,
            margin: '0 20px',
            padding: '40px 32px',
            background: 'linear-gradient(145deg, #1a1a2e 0%, #16162a 100%)',
            borderRadius: 20,
            boxShadow: '0 25px 60px rgba(0,0,0,0.5), 0 0 40px rgba(201,168,76,0.08)',
            border: '1px solid rgba(201,168,76,0.15)',
            animation: this.state.shake ? 'betaShake 0.5s ease' : 'none',
          }}
        >
          {/* Logo / Icon */}
          <div style={{
            textAlign: 'center',
            marginBottom: 8,
          }}>
            <div style={{
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: 64,
              height: 64,
              borderRadius: '50%',
              background: 'linear-gradient(135deg, #c9a84c, #b8953f)',
              boxShadow: '0 4px 20px rgba(201,168,76,0.3)',
              fontSize: 28,
            }}>
              <span role="img" aria-label="lock">&#128274;</span>
            </div>
          </div>

          <h1 style={{
            textAlign: 'center',
            color: '#ffffff',
            fontSize: 24,
            fontWeight: 700,
            margin: '16px 0 4px',
            letterSpacing: '-0.02em',
          }}>
            Primal Marketplace
          </h1>

          <div style={{
            textAlign: 'center',
            marginBottom: 28,
          }}>
            <span style={{
              display: 'inline-block',
              padding: '4px 14px',
              background: 'rgba(201,168,76,0.12)',
              border: '1px solid rgba(201,168,76,0.25)',
              borderRadius: 20,
              color: '#c9a84c',
              fontSize: 12,
              fontWeight: 700,
              letterSpacing: '0.08em',
              textTransform: 'uppercase',
            }}>
              Closed Beta
            </span>
          </div>

          <p style={{
            textAlign: 'center',
            color: '#8888a0',
            fontSize: 14,
            lineHeight: 1.6,
            margin: '0 0 28px',
          }}>
            Enter the beta access password to continue.
          </p>

          <form onSubmit={this.handleSubmit}>
            <div style={{ marginBottom: 16 }}>
              <input
                type="password"
                value={this.state.password}
                onChange={this.handleChange}
                placeholder="Beta password"
                autoFocus
                style={{
                  width: '100%',
                  padding: '14px 16px',
                  fontSize: 16,
                  color: '#ffffff',
                  background: 'rgba(255,255,255,0.06)',
                  border: this.state.error
                    ? '1.5px solid #ef4444'
                    : '1.5px solid rgba(255,255,255,0.1)',
                  borderRadius: 12,
                  outline: 'none',
                  transition: 'border-color 0.2s',
                  boxSizing: 'border-box',
                  fontFamily: "'Lato', sans-serif",
                }}
                onFocus={(e) => {
                  if (!this.state.error) {
                    e.target.style.borderColor = '#c9a84c';
                  }
                }}
                onBlur={(e) => {
                  if (!this.state.error) {
                    e.target.style.borderColor = 'rgba(255,255,255,0.1)';
                  }
                }}
              />
              {this.state.error && (
                <p style={{
                  color: '#ef4444',
                  fontSize: 13,
                  margin: '8px 0 0 4px',
                }}>
                  {this.state.error}
                </p>
              )}
            </div>

            <button
              type="submit"
              style={{
                width: '100%',
                padding: '14px 0',
                fontSize: 15,
                fontWeight: 700,
                color: '#0a0a0f',
                background: 'linear-gradient(135deg, #c9a84c, #b8953f)',
                border: 'none',
                borderRadius: 12,
                cursor: 'pointer',
                transition: 'opacity 0.2s, transform 0.15s',
                fontFamily: "'Lato', sans-serif",
                letterSpacing: '0.02em',
              }}
              onMouseEnter={(e) => e.target.style.opacity = '0.9'}
              onMouseLeave={(e) => e.target.style.opacity = '1'}
            >
              Enter Beta
            </button>
          </form>
        </div>

        <style>{`
          @keyframes betaShake {
            0%, 100% { transform: translateX(0); }
            20% { transform: translateX(-12px); }
            40% { transform: translateX(10px); }
            60% { transform: translateX(-8px); }
            80% { transform: translateX(6px); }
          }
        `}</style>
      </div>
    );
  }
}

export default BetaGate;
